import React, { useEffect, useState } from "react";

const TopHeader = () => {
  return (
    <div className="TopHeader">
      <div className="Text">
        <p>Need help using this Portal?</p>
        <a href="https://docs.interconnecta.com/jadgrp-cma-0311frm">https://docs.interconnecta.com/jadgrp-cma-0311frm/</a>
      </div>
    </div>
  );
};

export default TopHeader;
